import React from "react";

// react-bootstrap components
import { Card, Container, Row, Col } from "react-bootstrap";

const portfolioItems = [
  {
    url: "http://rlaxodbs72.cafe24app.com/",
    period: "2025.03.07 ~ 2025.03.24",
    members: "1명",
    tools:
      "cafe24 node.js 호스팅, 서브라임텍스트, 소스트리, express.js, angular.js, 부트스트랩",
    desc: "angular.js 포트폴리오입니다.",
  },
  {
    url: "http://rlaxodbs71.cafe24app.com/",
    period: "2025.01.10 ~ 2025.01.16",
    members: "1명",
    tools:
      "cafe24 node.js 호스팅, 서브라임텍스트, 소스트리, express.js, vue.js, 부트스트랩",
    desc: "vue.js + node.js + express 구조로 제작한 저(김태윤) 자체를 취업을 홍보하는 개인포트폴리오입니다.",
  },
  {
    url: "http://rlaxodbs69.cafe24app.com/",
    period: "2022.11.14 ~ 2022.11.14",
    members: "1명",
    tools: "서브라임텍스트, 소스트리",
    desc: "node.js 를 이용한 개인포트폴리오 홈페이지 구현",
  },
];

function Typography() {
  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">포트폴리오/기타문서</Card.Title>
              </Card.Header>
              <Card.Body>
                {portfolioItems.map((item, idx) => (
                  <div className="portfolio-list-item" key={idx}>
                    <div className="portfolio-list-item-label">
                      포트폴리오
                    </div>
                    <div className="portfolio-list-item-body">
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fas fa-link"></i> {item.url}
                      </a>
                      <div className="portfolio-list-item-meta">
                        <strong>작업기간</strong> {item.period}
                        <span className="divider">|</span>
                        <strong>작업인원</strong> {item.members}
                      </div>
                      <div className="portfolio-list-item-row">
                        <strong>작업 툴</strong> {item.tools}
                      </div>
                      <div className="portfolio-list-item-row">
                        <strong>작품소개</strong> {item.desc}
                      </div>
                    </div>
                  </div>
                ))}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Typography;
